import React, { FunctionComponent } from "react";
import AppRouter from "./components/Router";
import ThemeWrapper from "./components/ThemeWrapper";

const App: FunctionComponent = () => {
  return (
    <ThemeWrapper>
      <AppRouter />
    </ThemeWrapper>
  );
};

export default App;
